import {
  ASRTP_ICON,
  CENTRAL_DISPATCHING_ICON,
  ELECTRICAL_INSTALLATIONS_ICON,
  MEASUREMENT_REGULATION_ICON,
  WATER_MANAGEMENT_ICON,
} from "@/components/icons/icons";
import { ImagesEnum } from "@/model/enum/ImagesEnum";
import { RoutesEnum } from "@/model/enum/RoutesEnum";
import { SolutionTypeEnum } from "@/model/enum/SolutionTypeEnum";

export const vodarenstvo = {
  nameKey: "solutions:vodarenstvo.name",
  descriptionKey: "solutions:vodarenstvo.description",
  href: `${RoutesEnum.SOLUTIONS}/${SolutionTypeEnum.VODARENSTVO}`,
  icon: WATER_MANAGEMENT_ICON,
  imageUrl: ImagesEnum.VODARENSTVO,
  type: SolutionTypeEnum.VODARENSTVO,

  detailsPageHeroDescriptionKey:
    "solutions:vodarenstvo.detailsPageHeroDescription",

  experienceKey: "solutions:vodarenstvo.experience",
  experiencePointsKey: "solutions:vodarenstvo.experiencePoints",

  ourFocusDescriptionKey: "solutions:vodarenstvo.ourFocusDescription",
  ourFocusPoints: [
    {
      icon: ELECTRICAL_INSTALLATIONS_ICON,
      titleKey: "solutions:vodarenstvo.ourFocusPoints.0.title",
      descriptionKey: "solutions:vodarenstvo.ourFocusPoints.0.description",
    },
    {
      icon: MEASUREMENT_REGULATION_ICON,
      titleKey: "solutions:vodarenstvo.ourFocusPoints.1.title",
      descriptionKey: "solutions:vodarenstvo.ourFocusPoints.1.description",
    },
    {
      icon: ASRTP_ICON,
      titleKey: "solutions:vodarenstvo.ourFocusPoints.2.title",
      descriptionKey: "solutions:vodarenstvo.ourFocusPoints.2.description",
    },
    {
      icon: CENTRAL_DISPATCHING_ICON,
      titleKey: "solutions:vodarenstvo.ourFocusPoints.3.title",
      descriptionKey: "solutions:vodarenstvo.ourFocusPoints.3.description",
    },
  ],

  sectionWithImage: {
    subtitleKey: "solutions:vodarenstvo.sectionWithImage.subtitle",
    titleKey: "solutions:vodarenstvo.sectionWithImage.title",
    descriptionKey: "solutions:vodarenstvo.sectionWithImage.description",
    imageUrl: ImagesEnum.SECTION_WITH_IMAGE,
    sectionPointsKey: "solutions:vodarenstvo.sectionWithImage.sectionPoints",
  },
  section: null,
  solutionsForTopic: [
    {
      titleKey: "solutions:vodarenstvo.solutionsForTopic.title",
      descriptionKey: "solutions:vodarenstvo.solutionsForTopic.description",
      pointsKey: "solutions:vodarenstvo.solutionsForTopic.points",
    },
  ],
};
